import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { DialogSize } from '@aiwyn/shared';
import { ConsentValues } from '../../models';
import { EngagementConsentSettings } from '@aiwyn/api';
import { map, Observable, shareReplay } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';

export interface ProvideOrDenyConsentDialogData {
  initialValue: ConsentValues;
  isRequired: boolean;
  settings: EngagementConsentSettings,
}

@Component({
  selector: 'app-provide-or-deny-consent-dialog',
  templateUrl: './provide-or-deny-consent-dialog.component.html',
  styleUrl: './provide-or-deny-consent-dialog.component.scss',
  standalone: false,
})
export class ProvideOrDenyConsentDialogComponent {
  readonly ConsentValues = ConsentValues;
  readonly DialogSize = DialogSize;
  readonly consentStatusControl = new FormControl(this.data.initialValue ?? ConsentValues.OFF);

  readonly dialogSize$: Observable<DialogSize> = this._breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(
      map((state) => this._getDialogSizeForScreenSize(state)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

  isConsentSubmitted = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ProvideOrDenyConsentDialogData,
    private readonly _dialogRef: MatDialogRef<ProvideOrDenyConsentDialogComponent, ConsentValues>,
    private readonly _breakpointObserver: BreakpointObserver
  ) { }

  onSubmitConsent(): void {
    this.isConsentSubmitted = true;
    if (this.data.isRequired && this.consentStatusControl.value === ConsentValues.OFF) {
      return;
    }

    this._dialogRef.close(this.consentStatusControl.value);
  }

  private _getDialogSizeForScreenSize({ breakpoints }: BreakpointState): DialogSize {
    if (breakpoints[Breakpoints.XSmall]) {
      return DialogSize.EXTRA_SMALL;
    }

    if (breakpoints[Breakpoints.Small]) {
      return DialogSize.SMALL;
    }

    return DialogSize.MEDIUM;
  }
}
